module.exports = __webpack_public_path__ + "img/thumb_document_docx.3254e5cb.svg";